import { h } from '..//index.js';
export const selectVoucherTypes = (state) => {
    const economyVoucherTypes = state.economyVoucherTypes;
    if (!h.hasData(economyVoucherTypes)) {
        return null;
    }
    return economyVoucherTypes.data;
};
export const selectVoucherTypesMap = (state) => {
    const voucherTypesMap = state.economyVoucherTypesMap;
    return voucherTypesMap || {};
};
export const selectVoucherTypesIsLoading = (state) => {
    const economyVoucherTypes = state.economyVoucherTypes;
    return h.isLoading(economyVoucherTypes);
};
export const selectDepositsInsights = (state) => {
    const depositsInsights = state.economyDepositsInsights;
    if (!h.isLoaded(depositsInsights)) {
        return null;
    }
    return depositsInsights.data;
};
//# sourceMappingURL=selectors.js.map